import { render, staticRenderFns } from "./IntegralOrderSubmission.vue?vue&type=template&id=b31f2ddc&scoped=true&"
import script from "./IntegralOrderSubmission.vue?vue&type=script&lang=js&"
export * from "./IntegralOrderSubmission.vue?vue&type=script&lang=js&"
import style0 from "./IntegralOrderSubmission.vue?vue&type=style&index=0&id=b31f2ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31f2ddc",
  null
  
)

export default component.exports